export default __webpack_public_path__ + "static/media/v3.22c8c459.svg";